import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { thunk } from "redux-thunk";

import userAccountReducer from "./reducers/userAccountSlice";
import navigationReducer from "./reducers/navigationSlice";

const persistConfig = { key: "root", storage, blacklist: ["navigation"] };
const rootReducer = combineReducers({
  userAccount: userAccountReducer,
  navigation: navigationReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: () => [thunk],
});

export const persistor = persistStore(store);
